import React from 'react'

function Footer() {
  return (
    <div className='flex flex-col items-center justify-center p-2'>
      <p className='text-[8px] text-highlight'>
        Copyright © 2024 Edro Gonzales | Made with React & Tailwind
      </p>
    </div>
  )
}

export default Footer
